import { httpClient } from "./httpClient";
import {
  CommentsResponse,
  CreateCommentRequest,
  GetPostsRequest,
  NumberServiceResponse,
  Post,
  PostsResponse,
  TreeViewListResponse,
} from "../models";

const buildPostsPayload = (payload = {}) => {
  if (payload instanceof GetPostsRequest) {
    return payload.toPayload();
  }
  return new GetPostsRequest(payload).toPayload();
};


export const getTopSlider = async () => {
  const response = await httpClient.get(
    "/api/News/TopSlider"
  );
  return (response.data ?? []);
};

export const getOrganPicture = async () => {
  const response = await httpClient.get(
    "/api/Organ/GetAll"
  );
  return (response.data ?? []);
};

/**
 * Retrieve a paginated list of posts based on filters.
 */
export const getPosts = async (payload) => {
  const model = buildPostsPayload(payload)
  const response = await httpClient.post(
    "/api/News/GetAll",
    model
  );
  return new PostsResponse(response.data ?? {});
};

/**
 * Retrieve posts sorted by visit count.
 */
export const getPostsByVisit = async (payload) => {
  const response = await httpClient.post(
    "/api/News/GetAllByVisit",
    buildPostsPayload(payload)
  );
  return new PostsResponse(response.data ?? {});
};

/**
 * Fetch highlighted news cards for the home page hero.
 */
export const getSonehomeNewsCards = async ({ take = 3 } = {}) => {
  const sliderResponse = await getSliderNews();
  const takeCount = Number.isFinite(Number(take)) ? Number(take) : 3;
  const posts = sliderResponse.posts.slice(0, takeCount > 0 ? takeCount : 0);

  return new PostsResponse({
    totalCount: sliderResponse.totalCount,
    posts,
  });
};

/**
 * Fetch slider data containing highlighted posts.
 */
export const getSliderNews = async () => {
  const response = await httpClient.get("/api/Post/ShowSliderNews");
  return new PostsResponse(response.data ?? {});
};

/**
 * Fetch a single post by id. Optionally pass the visitor IP for tracking.
 */
export const showPost = async ({ id, visitorIp } = {}) => {
  if (id === undefined || id === null) {
    throw new Error('showPost requires an "id" parameter.');
  }

  const response = await httpClient.get("/api/Post/ShowPost", {
    params: {
      id,
      visitorIp:"1",
    },
  });

  return new Post(response.data ?? {});
};

/**
 * Retrieve the printable version of a post.
 */
export const printPost = async (id) => {
  if (id === undefined || id === null) {
    throw new Error('printPost requires an "id" parameter.');
  }

  const response = await httpClient.get("/api/Post/PrintPost", {
    params: { id },
  });

  return new Post(response.data ?? {});
};

/**
 * Submit a new comment for a post.
 */
export const createComment = async (payload) => {
  const request = payload instanceof CreateCommentRequest
    ? payload
    : new CreateCommentRequest(payload);

  const response = await httpClient.post(
    "/api/Post/CreateComment",
    request.toPayload()
  );

  return new NumberServiceResponse(response.data ?? {});
};

/**
 * Fetch comments for a post.
 */
export const getComments = async ({ id, start = 0, length = 10 } = {}) => {
  if (id === undefined || id === null) {
    throw new Error('getComments requires an "id" parameter.');
  }

  const response = await httpClient.get("/api/Post/ShowComments", {
    params: {
      id,
      start,
      length,
    },
  });

  return new CommentsResponse(response.data ?? {});
};

/**
 * Load the tree of categories used when publishing posts.
 */
export const loadTreePostCategories = async ({ langId, selected } = {}) => {
  const response = await httpClient.post(
    "/api/Post/LoadTreePostCategories",
    {},
    {
      params: {
        ...(langId !== undefined && langId !== null ? { langId } : {}),
        ...(selected ? { selected } : {}),
      },
    }
  );

  return new TreeViewListResponse(response.data ?? {});
};



export const getCategoryHierarchy = async (parentId = 1006) => {
  const response = await httpClient.get(
    '/api/Category/Hierarchy',
    { params: { parentId } }
  );
  return Array.isArray(response?.data) ? response.data : [];
};